import * as React from "react";
import { useContext } from "react";
import { EditProjectContext } from "../../../EditProjectContext";
import { DropDownListType } from "../../LtlTab/LtlTabTable/RouteCell/DropDownListType";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { updateRoutePropertyOnProject } from "../RouteNumberArea/UpdateRoutePropertyOnProject";
import { DropDownList } from "../../../../../Layout/Inputs/DropDownList";
import TextInput from "../../../../../Layout/Inputs/TextInput";

type Props = {
  route: FtlRouteViewModel;
  isReadonly: boolean;
};

export function DestinationName({ route, isReadonly }: Props) {
  const projectContextProps = useContext(EditProjectContext);

  const { project } = projectContextProps;
  const list: Array<DropDownListType<string>> =
    project.DestinationNames?.map((x) => ({
      text: x,
      value: x,
    })) || [];

  if (isReadonly) {
    return (
      <TextInput
        label="Destination Name"
        name="DestinationName"
        value={route.DestinationName}
        disabled
      />
    );
  }

  return (
    <DropDownList
      label="Destination Name"
      list={list}
      value={route.DestinationName}
      onChange={(value) => {
        updateRoutePropertyOnProject(
          "DestinationName",
          value,
          route.RouteNumber || "",
          projectContextProps
        );
      }}
      disabled={isReadonly}
    />
  );
}
